<template>
  <div class="account-container py-4 col-12 col-lg-9 col-xl-9  mx-auto mb-5">
    <h4 class="w-100 text-center text-white my-3 my-lg-4 page-main-title">
      Аккаунт
    </h4>
    <div class="col-12 mx-auto text-center my-5 py-3 page-main-block px-0 px-lg-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-11 mt-3 mt-lg-3 mx-auto px-0">
        <b-tabs
                content-class="mt-0 mt-lg-3"
                class="tab account-tab px-0"
                nav-class="col-12 col-lg-8 mx-auto px-0">
          <b-tab class="account-tab-item col-12 px-0 py-4"
                 title="Профиль"
                 :active="activeTab==='profile'"
                 @click="onTabChange('profile')">
            <profile></profile>
          </b-tab>
          <b-tab class="tab-item"
                 title="Письма"
                 @click="onTabChange('messages')"
                 :active="activeTab==='messages'">
            <messages></messages>
          </b-tab>

          <b-tab class="tab-item"
                 title="Фриспины"
                 @click="onTabChange('freespins')"
                 :active="activeTab==='freespins'">
            <Freespins></Freespins>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Profile from '@/components/user/Profile'
import Messages from '@/components/user/Messages'
import Freespins from "@/components/user/Freespins";

export default {
  props: ['placeName', 'tab'],
  data () {
    return {
      activeTab: 'profile'
    }
  },
  components: {
    Freespins,
    Profile,
    Messages
  },
  computed: {
    userData () {
      return this.$store.getters.userData
    },
    userDataFetched () {
      return this.$store.getters.userDataFetched
    }
  },
  updated() {
    if (typeof this.placeName !== "undefined") {
      this.activeTab = this.placeName
    }
  },
  methods :{
    onTabChange (toRoute) {
      if (this.activeTab !== toRoute) {
        this.$router.push({ name: 'account', params: {placeName : toRoute} })
      }
    }
  },
  mounted () {
    if (typeof this.placeName !== "undefined") {
      this.activeTab = this.placeName
    } else if (this.$route.params && this.$route.params.placeName) {
      this.activeTab = this.$route.params.placeName
      this.$router.push({ name: 'account', params: {placeName : this.$route.params.placeName} })
    } else {
      this.$router.push({ name: 'account', params: {placeName : 'profile'} })
    }

    setTimeout(() => {
      if (this.userDataFetched && !this.userData) {
        this.$router.push({ name: 'login' })
      }
    }, 2500)
  },
  watch: {
    $route (to) {
      if (to && to.params && to.params.placeName) {
        this.activeTab = to.params.placeName
      }
    }
  }
}
</script>

<style>
  .account-tab .nav-tabs {
    border: none !important;
    margin-bottom: 30px;
    justify-content: center;
  }

  .account-tab .nav-tabs .nav-item {
    width: 30% !important;
    border: none !important;
    margin: 0;
  }

  .account-tab .nav-tabs .nav-item .nav-link {
    color: white !important;
    background-color: #191818;;
    border: none;
    padding: 8px 2px;
  }

  .account-tab .nav-tabs .nav-item .nav-link.active {
    background-color: #cf200c;
    color: white !important;
    padding: 8px 3px;
  }

  .account-tab .nav-tabs .nav-item .nav-link {
    border-radius: 0;
    margin: 0 15px;
    text-align: center;
  }

  .account-tab .nav-tabs .nav-item:first-child .nav-link::before {
    margin-right: 10px;
  }

  .account-tab .nav-tabs .nav-item:last-child .nav-link::before {
    margin-right: 10px;
  }

  .account-tab-item{
    background-color: transparent;
  }

  @media (min-width: 320px) and (max-width: 768px) {
    .account-tab .nav-tabs .nav-item {
      margin-bottom: 10px;
    }
    .account-tab .nav-tabs .nav-item .nav-link{
      margin: 0 5px;
    }
    .account-tab .nav-tabs {
      margin-bottom: 0;
    }
  }
</style>
<style>
  .page-main-block{
    background-color:#070a11;
    outline: none !important;
    background-origin: border-box;
    background-clip: padding-box, border-box;
    border-radius:4px;
    background-position: 0 100%, 100% 100%;
    background-repeat: no-repeat;
    background-size:  1px 100%;
    border-top: 1px solid rgba(255,255,255,0.6);
    border-bottom: 1px solid rgba(255,255,255,0.6);
    background-image:  linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%, #011e40 65%, rgba(255,255,255,0.6) 100%), linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, #011e40 35%,#011e40 65%, rgba(255,255,255,0.6) 100%);
    padding: 6px 10px;
    position: relative;
    z-index: 5;
  }
</style>
